export function ActiveIcon() {
  return (
    <svg width='16' height='16' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11 5.53993V5.99993C10.9994 7.07814 10.6503 8.12727 10.0047 8.99084C9.35908 9.85442 8.45164 10.4862 7.41768 10.7919C6.38372 11.0976 5.27863 11.0609 4.26724 10.6872C3.25584 10.3136 2.39233 9.62298 1.80548 8.71847C1.21863 7.81395 0.939896 6.74396 1.01084 5.66809C1.08178 4.59221 1.4986 3.5681 2.19914 2.74847C2.89968 1.92884 3.84639 1.35762 4.89809 1.12001C5.9498 0.882387 7.05013 0.991101 8.035 1.42993'
        stroke='#219653'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M11 2L6 7.005L4.5 5.505' stroke='#219653' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
